import React, { Component, Fragment } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
// import Invoice from "./components/reports/Invoice";
// import invoice from "./data/invoice";
// import InvoiceDemain from "./components/reports/InvoiceDamian";
import R4 from 'pages/stepper4/components/reports/R4v2';

// import logo from './logo.svg';
import './R3.css';

// from HrInspectionReport.jsx
// App.js, NinjaMain.js

class App extends Component {
  render() {
    return (
      <Fragment>
        {/* <PDFViewer width="1000" height="600" className="app"> */}
        {/* <Invoice invoice={invoice} /> */}
        {/* <InvoiceDemain /> */}
        <R4 />
        {/* </PDFViewer> */}
      </Fragment>
    );
  }
}

export default App;
